import styles from "../../../assets/css/popups/addinvoicepopup.module.css";
import BackBtn from "../../backbtn";
import { JSFunctions } from "../../../App";
import { useDispatch } from "react-redux";
import Toasts from "../../../assets/toasts/toasts";
import { useState } from "react";
import { Toaster } from "react-hot-toast";
import Overlay from "../../overlay";

function AddEmployeeWidgetState(props) {
  const [data, setData] = useState({
    name: "",
    raised_date: "",
    salary: ""
  });
  const [overlay, setOverlayState] = useState(false);
  const dispatch = useDispatch();
  const Toast = new Toasts();

  function cancle() {
    dispatch({ type: "", payload: { addEmployeeWidgetState: false } });
  }
  async function add(){
      if (data.name.length === 0 || data.raised_date.length === 0 || data.salary.length === 0) {
        Toast.error("يجب إدخال البيانات أولا")
      } else {
        let functions = new JSFunctions();
        setOverlayState(true);
        console.log(data)
        let res = await functions.addEmployee(JSON.stringify(data));
        setOverlayState(false);
        if (!res) {
            Toast.error("حدث خطأ.");
        } else {
            Toast.success("تم إضافة الموظف بنجاح")
        }
      }
  }

  return (
    <>
      <div className={styles["popup"]}>
        <div className={styles.header}>
          <h2 className={styles["title"]}>إضافة موظف</h2>
          <div onClick={() => cancle("addEmployeeWidgetState")}>
            <BackBtn />
          </div>
        </div>
        <div className={styles["gp"]}>
          <input
            className={styles["pop-up-input"]}
            value={data.name}
            onChange={(ele) => {
              setData({ ...data, name: ele.target.value });
            }}
            placeholder="الإسم"
          ></input>
        </div>
        <div className={styles["gp"]}>
          <input
            className={styles["pop-up-input"]}
            value={data.salary}
            type="number"
            onChange={(ele) => {
              setData({ ...data, salary: ele.target.value });
            }}
            placeholder="المرتب"
          ></input>
                    <input
            className={styles["pop-up-input"]}
            value={data.raised_date}
            type="number"

            onChange={(ele) => {
              setData({ ...data, raised_date: ele.target.value });
            }}
            placeholder="معاد تسليم الراتب (يوم)"
          ></input>
        </div>
      <button onClick={add}>حفظ</button>

      </div>
      <Toaster position="top-left" reverseOrder={false} />
      {overlay ? <Overlay></Overlay> : null}
    </>
  );
}

export default AddEmployeeWidgetState;
